class Callbacks {
  static filterToFormHandler() {
    return function filterToForm(filter) {
      return filter
    }
  }
  static filterToStateHandler(user) {
    return function filterToState(state) {
      return { user }
    }
  }
  static formToFilterHandler() {
    return function formToFilter(values, extra, meta, state) {
      return {
        ...values,
        user: _.get(state, 'user')
      }
    }
  }
}

export default Callbacks
